import React from "react";
import { Link } from "gatsby-plugin-intl";
import classnames from "classnames";
import cssClass from "./ButtonLink.module.scss";

const ButtonLink = ({
  children,
  to,
  className,
  alternative,
  alternativeInvert,
  blackGhost,
  whiteGhost,
}) => {
  const classes = classnames(cssClass.link, className, {
    [cssClass.alternative]: alternative,
    [cssClass.alternativeInvert]: alternativeInvert,
    [cssClass.blackGhost]: blackGhost,
    [cssClass.whiteGhost]: whiteGhost,
  });

  return (
    <Link to={to} className={classes}>
      {children}
    </Link>
  );
};

export default ButtonLink;
